import React from 'react'
import { Button, Affix, Alert } from 'antd'
import { Loading } from '@guillotinaweb/react-gmi'
import { LeftOutlined } from '@ant-design/icons'

import 'antd/dist/antd.css'

export function ContentLayout({
  title,
  displayBackBtn,
  buttonLabel,
  buttonAction,
  children,
  loading,
  error,
  className = '',
}) {
  return (
    <div
      className={`container ${className}`}
      style={{ backgroundColor: '#fff', padding: 30 }}
    >
      <Affix>
        <div className="level" style={{ padding: 10, backgroundColor: '#fff' }}>
          <div className="level-left">
            <h2 className="title is-size-5">{title}</h2>
          </div>
          {buttonLabel && (
            <div className="level-right is-size-7">
              {displayBackBtn && (
                <>
                  <Button onClick={() => window.history.back()}>
                    <LeftOutlined />
                    Go back
                  </Button>
                  &nbsp;&nbsp;
                </>
              )}
              <Button disable={loading} type="primary" onClick={buttonAction}>
                {buttonLabel}
              </Button>
            </div>
          )}
        </div>
      </Affix>
      {(() => {
        if (loading) return <Loading />
        if (error) return <Error message={error.message} />
        return children
      })()}
    </div>
  )
}

export function Error({ message }) {
  return <Alert message="Error" description={message} type="error" showIcon />
}
